import { Routes } from '@angular/router';
import { OrderComponent } from './order/order.component';
import { ViewDocsComponent } from './view-docs/view-docs.component';
import { OrderCancellationComponent } from './order-cancellation/order-cancellation.component';
import { OrderCancellationConfirmationComponent } from './order-cancellation/order-cancellation-confirmation/order-cancellation-confirmation.component';
import { WebIdComponent } from './web-id/web-id.component';
import {TankkarteComponent} from './tankkarte/tankkarte.component';
import {ChangePaymentUploadComponent} from './change-payment-upload/change-payment-upload.component';
import {PaymentUploadSuccessComponent} from './payment-upload-success/payment-upload-success.component';
import {SmsVerificationComponent} from './sms-verification/sms-verification.component';
import {ChangePaymentComponent} from './change-payment/change-payment.component';
import {ChangeEmailConfirmationComponent} from './change-email-confirmation/change-email-confirmation.component';
import {OnfidoComponent} from './onfido/onfido.component';
import {IdentComponent} from './ident/ident.component';
import {VerificationCompleteComponent} from './verification-complete/verification-complete.component';
import {OrderSummaryLinkpageComponent} from './order-summary-linkpage/order-summary-linkpage.component';
import {ReferralComponent} from './referral/referral/referral.component';
import {GetAppComponent} from './get-app/get-app.component';
import {FxRateComponent} from './fx-rate/fx-rate.component';
import {AccountDeletionComponent} from "./account-deletion/account-deletion.component";
import {
  AccountDeletionConfirmationComponent
} from "./account-deletion/account-deletion-confirmation/account-deletion-confirmation.component";
import {BrandReferralComponent} from "./referral/brand-referral/brand-referral.component";
import {OpenInAppComponentComponent} from "../open-in-app-component/open-in-app-component.component";

export const orderAssistantRoutes: Routes = [
  { path: 'sms', children: [
      { path: '', component: SmsVerificationComponent },
    ]},
  { path: 'change-email', children: [
      { path: 'confirm', component: ChangeEmailConfirmationComponent },
  ]},
  { path: 'referral', component: ReferralComponent },
  { path: 'brand/:brandReferralCode', component: BrandReferralComponent },
  { path: 'order/:id', component: OrderComponent },
  { path: 'ident/:orderKey', component: IdentComponent },
  { path: 'total-card', component: TankkarteComponent },
  { path: 'order-cancellation', children: [
    { path: '', component: OrderCancellationComponent },
    { path: 'confirm', component: OrderCancellationConfirmationComponent },
  ]},
  { path: 'account-deletion', children: [
      { path: '', component: AccountDeletionComponent },
      { path: 'confirm', component: AccountDeletionConfirmationComponent },
    ]},
  { path: 'web-id-tranaction/:id', component: WebIdComponent },
  { path: 'documents', children: [
    { path: ':name', component: ViewDocsComponent }
  ]},
  { path: 'change-payment/:orderId', component: ChangePaymentComponent },

  { path: 'change-payment-upload/:invoiceCode', component: ChangePaymentUploadComponent },
  { path: 'upload-doc-payment-success', component: PaymentUploadSuccessComponent },
  { path: 'ident-complete', component: VerificationCompleteComponent },
  { path: 'onfido', children:[
    {path: '', component: OnfidoComponent }
  ]},
  { path: 'order-summary/link', component: OrderSummaryLinkpageComponent },
  { path: 'get', component: GetAppComponent },
  { path: 'app', children: [
      {path: '', component: GetAppComponent },
      {path: 'consent/tell-tpp', component: OpenInAppComponentComponent },
    ]
  },
  { path: 'fx-rate', component: FxRateComponent },


];
